export const labels = {
    tamil: {
        formHeader: "வெளி நோயாளி பதிவு தகவல் படிவம்",
        patientName: "நோயாளியின் பெயர்",
        gender: "பாலினம்",
        age: "வயது",
        DOB: "பிறந்த தேதி",
        maritalStatus: "திருமண நிலை",
        unMarried: "திருமணமாகாதவர்",
        married: "திருமணமானவர்",
        fatherHusbandName: "தந்தை/கணவன் பெயர்",
        address1: "முகவரி 01",
        address2: "முகவரி 02",
        city: "நகரம்",
        state: "மாநிலம்",
        pincode: "பின்கோடு",
        occupation: "தொழில்",
        guardianName: "பாதுகாப்பாளர் பெயர்",
        mobileNo: "கைபேசி எண்",
        emailId: "மின்னஞ்சல் முகவரி",
        referralSource: "நீங்கள் எங்களை எப்படித் தெரிந்துகொண்டீர்கள்?",
        terms: "நான் இந்த நேரத்தை முன்பதிவு செய்வதற்கான விதிமுறைகள் மற்றும் நிபந்தனைகளை ஏற்கின்றேன்.",
        description: 'மருத்துவமனையில் சிகிச்சையைப் பற்றிய விதிமுறைகள், ஒழுங்குகள் மற்றும் கட்டணங்கள் குறித்து எனக்கு தகவல் வழங்கப்பட்டுள்ளது.மருத்துவமனை மருத்தவர்கள் மற்றும் நர்ச்கள் என்னை(அல்லது என் பொறுப்பில் உள்ள நோயாளரை) பரிசோதிக்க எனது சம்மதத்தை வழங்குகிறேன்.இதில் தேவையான பரிசோதனைகள், நடைமுறைகள் மற்றும் சிகிச்சைகள் உட்பட அனைத்தும் சுகாதார சேவை வழங்குநர்கள் பரிந்துரைக்கும் விதத்தில் மேற்கொள்ளலாம்.என் நலனும் பாதுகாப்பும் கருதி மருத்துவ பணியாளர்கள் அனைத்து பொருத்தமான முன்னெச்சரிக்கைகளையும் எடுப்பார்கள் என்பதை நான் புரிந்துகொள்கிறேன், ஆனால் எந்தவொரு மருத்துவ நடைமுறையிலும் சில உட்பிறப்பு அபாயங்கள் இருக்கலாம் என்பதையும் நான் ஒப்புக்கொள்கிறேன்.',
        submit: "சமர்ப்பிக்கவும்",
    },
    hindi: {
        formHeader: "बाह्य रोगी पंजीकरण सूचना फॉर्म",
        patientName: "मरीज़ का नाम",
        gender: "लिंग",
        age: "उम्र",
        DOB: "जन्म तिथि",
        maritalStatus: "वैवाहिक स्थिति",
        unMarried: "अविवाहित",
        married: "विवाहित",
        fatherHusbandName: "पिता/पति का नाम",
        address1: "पता 01",
        address2: "पता 02",
        city: "शहर",
        state: "राज्य",
        pincode: "पिनकोड",
        occupation: "उपजीविका",
        guardianName: "अभिभावक का नाम",
        mobileNo: "मोबाइल नंबर",
        emailId: "ईमेल आईडी",
        referralSource: "आपको हमारे बारे में कैसे पता चला?",
        terms: "मैं इस अपॉइंटमेंट को बुक करने के लिए नियम और शर्तों से सहमत हूँ।",
        description: 'मुझे अस्पताल में उपचार से संबंधित नियमों, विनियमों और शुल्कों की जानकारी दी गई है।मैं अपनी सहमति देता/देती हूँ कि मुझे (या उस रोगी को जिसकी जिम्मेदारी मेरी है) अस्पताल के डॉक्टरों और नर्सों द्वारा जांचा जाए।इसमें आवश्यक परीक्षण, प्रक्रियाएं और उपचार शामिल हैं, जैसा कि स्वास्थ्य सेवा प्रदाताओं द्वारा निर्धारित किया गया है।मैं समझता/समझती हूँ कि चिकित्सा कर्मचारी मेरी भलाई और सुरक्षा के लिए सभी उचित सावधानियां बरतेंगे, लेकिन मैं यह भी स्वीकार करता/करती हूँ कि किसी भी चिकित्सा प्रक्रिया या उपचार से कुछ अंतर्निहित जोखिम जुड़े हो सकते हैं।',
        submit: "जमा करें"
    },
    malayalam: {
        formHeader: "ഔട്ട് പേഷ്യന്റ് രജിസ്ട്രേഷൻ ഇൻഫർമേഷൻ ഫോം",
        patientName: "രോഗിയുടെ പേര്",
        gender: "ലിംഗഭേദം",
        age: "പ്രായം",
        DOB: "ജനനത്തീയതി",
        maritalStatus: "വൈവാഹിക നില",
        unMarried: "അവിവാഹിതൻ",
        married: "വിവാഹിതൻ",
        fatherHusbandName: "പിതാവ് / ഭർത്താവിൻ്റെ പേര്",
        address1: "വിലാസം 01",
        address2: "വിലാസം 02",
        city: "നഗരം",
        state: "സംസ്ഥാനം",
        pincode: "പിൻ കോഡ്",
        occupation: "തൊഴിൽ",
        guardianName: "ഗാർഡിയൻ നാമം",
        mobileNo: "മൊബൈൽ നമ്പർ",
        emailId: "ഇമെയിൽ ഐഡി",
        referralSource: "റഫറൽ ഉറവിടം",
        terms: "ബുക്കിംഗ് നടത്തുന്നതിന് വേണ്ടി ആശുപത്രി നിബന്ധനകൾ ഞാൻ അംഗീകരിക്കുന്നു",
        description: 'ആശുപത്രിയിലെ ചികിത്സയുമായി ബന്ധപ്പെട്ട നിയമങ്ങൾ, ചട്ടങ്ങൾ, നിരക്കുകൾ എന്നിവയെക്കുറിച്ച് എന്നെ അറിയിച്ചിട്ടുണ്ട്. ആശുപത്രിയിലെ ഡോക്ടർമാരും നഴ്‌സുമാരും പരിശോധിക്കുന്നതിന് (അല്ലെങ്കിൽ ഞാൻ പരിശോധിക്കേണ്ട ഉത്തരവാദിത്തമുള്ള രോഗിയെ) ഞാൻ സമ്മതം നൽകുന്നു. ആരോഗ്യ സംരക്ഷണ ദാതാക്കൾ നിർദ്ദേശിക്കുന്ന ആവശ്യമായ പരിശോധനകൾ, നടപടിക്രമങ്ങൾ, ചികിത്സകൾ എന്നിവ ഇതിൽ ഉൾപ്പെടുന്നു. എന്റെ ക്ഷേമത്തിനും സുരക്ഷയ്ക്കും വേണ്ടി മെഡിക്കൽ സ്റ്റാഫ് എല്ലാ ന്യായമായ മുൻകരുതലുകളും എടുക്കുമെന്ന് ഞാൻ മനസ്സിലാക്കുന്നു, എന്നാൽ ഏതൊരു മെഡിക്കൽ നടപടിക്രമവുമായോ ചികിത്സയുമായോ അന്തർലീനമായ അപകടസാധ്യതകൾ ബന്ധപ്പെട്ടിരിക്കുന്നുവെന്ന് ഞാൻ സമ്മതിക്കുന്നു.',
        submit: "സമർപ്പിക്കുക"
    }
};
export const feedbacklabel = {
 
  tamil: {
    hospital_feedback_form: "மருத்துவமனை கருத்துக் கேட்பு படிவம்",
    experience_intro:
      "எங்கள் மருத்துவமனையில் உங்களின் அனுபவம் சிறப்பாக இருந்திருக்கிறது என்று நம்புகிறோம். எங்கள் சேவைகளை மேலும் மேம்படுத்த, இந்த கருத்துக் கேட்பை நிரப்ப சில நிமிடங்கள் ஒதுக்கினால் நலன்.",
    patient_information: "நோயாளர் தகவல்",
    type_of_visit: "வருகை வகை",
    opd: "வெளிநோயாளர்",
    ipd: "உட்பிரிவு நோயாளர்",
    emergency: "அவசர சேவை",
    department_visited: "சென்ற பிரிவு",
    date_of_visit: "வருகை தேதி",

    // Doctor & Care
    doctor_experience: "மருத்துவர் மற்றும் சிகிச்சை அனுபவம்",
    consultant_doctor: "ஆலோசனை மருத்துவர்",
    timely_medication_care: "சரியான நேரத்தில் மருந்தளிப்பு மற்றும் பராமரிப்பு",

    // Appointment & Registration
    appointment_registration: "சந்திப்பு மற்றும் பதிவு செயல்முறை",
    ease_of_appointment: "சந்திப்பு நேரத்தை பெறுவது எளிதா?",
    info_about_doctor: "மருத்துவர் பற்றிய தகவல் கிடைத்ததா?",
    registration_courtesy: "பதிவுத் தள ஊழியர்களின் அரவணைப்பு மற்றும் மரியாதை",

    // Waiting Time
    waiting_time: "காத்திருப்பு நேரம்",
    waiting_comfort: "உங்கள் முறைக்காக காத்திருக்கும்போது வசதியாக இருந்ததா?",

    // Staff
    staff_behavior: "ஊழியர்களின் நடத்தை மற்றும் தகவல் தொடர்பு",
    staff_courtesy: "மருத்துவமனை ஊழியர்களின் உபயம் மற்றும் உதவிகரமான தன்மை",

    // Pharmacy
    pharmacy_experience: "மருந்தக அனுபவம்",
    medicine_availability: "பரிந்துரைக்கப்பட்ட மருந்துகளின் கிடைக்கும் தன்மை",
    pharmacy_courtesy_speed:
      "மருந்தக சேவையின் உபயம் மற்றும் வேகம்",

    // Billing
    billing_payment: "பில் மற்றும் கட்டணம் செயல்முறை",
    billing_transparency: "பில் தெளிவாகவும் மற்றும் வெளிப்படையாகவும் இருந்ததா?",

    // Cleanliness
    hospital_cleanliness: "மருத்துவமனையின் தூய்மை",
    cleanliness_hygiene: "தூய்மை மற்றும் சுகாதார நிலை",

    // Overall Experience
    overall_experience: "மொத்த அனுபவம்",
    overall_experience_at_hospital:
      "மருத்துவமனையில் உங்களின் மொத்த அனுபவம்",

    // Why Choose
    why_choose_hospital: "இந்த மருத்துவமனையை ஏன் தேர்ந்தெடுத்தீர்கள்?",
    doctor_recommendation: "மருத்துவர் பரிந்துரை",
    location: "இடம்",
    insurance_requirement: "காப்பீட்டு தேவை",
    friend_relative_recommendation:
      "நண்பர் மற்றும் உறவினர் பரிந்துரை",
    past_experience: "பழைய அனுபவம்",
    online_reviews: "ஆன்லைன் மதிப்புரைகள் / இணையதளம்",
    hospital_reputation: "மருத்துவமனை நற்பெயர்",
    other_reason: "பிற காரணம்",


    // NPS
    nps: "பரிந்துரைக்கும் வாய்ப்பு அளவு (NPS)",
    nps_question:
      "0–10 அளவில், இந்த மருத்துவமனையை பிறருக்கு பரிந்துரைக்கும் வாய்ப்பு எவ்வளவு?",

    // Suggestions
    suggestions: "பரிந்துரைகள் / புகார்கள் / பாராட்டுகள்",
    suggestions_placeholder:
      "உங்களுக்கு பிடித்தது என்ன? எதை மேம்படுத்தலாம் என்பதைப் பகிரவும்.",

    // Contact Permission
    contact_permission: "தொடர்பு கொள்ள அனுமதி",
    contact_permission_question:
      "உங்கள் கருத்து தொடர்பாக நாங்கள் உங்களைத் தொடர்பு கொள்ள விரும்புகிறீர்களா?",
    yes: "ஆம்",
    no: "இல்லை",
    please_provide_it:'உங்களிடம் மற்றொரு எண் இருந்தால், தயவுசெய்து அதை வழங்கவும்.',
    alternative_mobile:'மாற்று மொபைல் எண்',
  },

  hindi: {
    hospital_feedback_form: "अस्पताल फीडबैक फ़ॉर्म",
    experience_intro:
      "हम आशा करते हैं कि हमारे अस्पताल में आपका अनुभव आरामदायक रहा होगा। कृपया कुछ समय निकालकर इस सर्वे को पूरा करें। आपकी प्रतिक्रिया हमें अपनी सेवाओं और देखभाल को और बेहतर बनाने में मदद करेगी।",

    // Patient Info
    patient_information: "रोगी की जानकारी",
    type_of_visit: "आपकी यात्रा का प्रकार",
    opd: "आउट पेशेंट",
    ipd: " इन पेशेंट",
    emergency: "आपातकाल",
    department_visited: "किस विभाग का दौरा किया",
    date_of_visit: "यात्रा की तारीख",

    // Doctor
    doctor_experience: "डॉक्टर और देखभाल का अनुभव",
    consultant_doctor: "परामर्श देने वाले डॉक्टर",
    timely_medication_care: "समय पर दवाई और देखभाल",

    // Appointment
    appointment_registration: "अपॉइंटमेंट और पंजीकरण",
    ease_of_appointment: "अपॉइंटमेंट लेने में आसानी",
    info_about_doctor: "डॉक्टर के बारे में जानकारी",
    registration_courtesy:
      "पंजीकरण डेस्क पर व्यवहार और सहयोग",

    // Waiting
    waiting_time: "प्रतीक्षा समय",
    waiting_comfort: "अपनी बारी की प्रतीक्षा करते समय सुविधा",

    // Staff
    staff_behavior: "स्टाफ का व्यवहार और संवाद",
    staff_courtesy:
      "अस्पताल स्टाफ का सहयोग और विनम्रता",

    // Pharmacy
    pharmacy_experience: "फार्मेसी का अनुभव",
    medicine_availability: "लिखी गई दवाइयों की उपलब्धता",
    pharmacy_courtesy_speed:
      "फार्मेसी सेवा की विनम्रता और गति",

    // Billing
    billing_payment: "बिलिंग और भुगतान प्रक्रिया",
    billing_transparency: "बिलिंग की स्पष्टता और पारदर्शिता",

    // Cleanliness
    hospital_cleanliness: "अस्पताल की स्वच्छता",
    cleanliness_hygiene: "सफ़ाई और स्वच्छता",

    // Overall
    overall_experience: "समग्र अनुभव",
    overall_experience_at_hospital:
      "अस्पताल में कुल अनुभव",

    // Why Choose
    why_choose_hospital: "आपने यह अस्पताल क्यों चुना?",
    doctor_recommendation: "डॉक्टर की सलाह",
    location: "स्थान",
    insurance_requirement: "बीमा से संबंधित आवश्यकताएँ",
    friend_relative_recommendation:
      "मित्र/रिश्तेदार की सलाह",
    past_experience: "पिछला अनुभव",
    online_reviews: "ऑनलाइन समीक्षा / वेबसाइट",
    hospital_reputation: "अस्पताल की प्रतिष्ठा",
    other_reason: "अन्य",

    // NPS
    nps: "नेट प्रमोटर स्कोर (NPS)",
    nps_question:
      "0 से 10 के पैमाने पर, आप इस अस्पताल को दूसरों को सुझाने की कितनी संभावना रखते हैं?",

    // Suggestions
    suggestions: "सुझाव / शिकायतें / प्रशंसा",
    suggestions_placeholder:
      "कृपया बताएं कि आपको क्या पसंद आया और सुधार के लिए आपके सुझाव क्या हैं।",

    // Contact Permission
    contact_permission: "संपर्क करने की अनुमति",
    contact_permission_question:
      "क्या आप चाहते हैं कि आपकी फीडबैक के बारे में हम आपसे संपर्क करें?",
    yes: "हाँ",
    no: "नहीं",
    please_provide_it:'अगर आपके पास कोई और नंबर है, तो कृपया उसे प्रदान करें.',
    alternative_mobile:'वैकल्पिक मोबाइल नंबर',
  },

  malayalam: {
  hospital_feedback_form: "ആശുപത്രി ഫീഡ്ബാക്ക് ഫോം",
  experience_intro:
    "ഞങ്ങളുടെ ആശുപത്രിയിലെ നിങ്ങളുടെ അനുഭവം സുഖകരമായിരുന്നുവെന്ന് പ്രതീക്ഷിക്കുന്നു. ഞങ്ങൾ നൽകുന്ന സേവനങ്ങൾ മെച്ചപ്പെടുത്താൻ സഹായിക്കുന്നതിനു  വേണ്ടി  ഈ സർവേ പൂർത്തിയാക്കാൻ നിങ്ങൾ കുറച്ച് നിമിഷങ്ങൾ ചിലവഴിച്ചാൽ ഞങ്ങൾ വളരെ നന്ദിയുള്ളവരായിരിക്കും.",

  // Patient Information
  patient_information: "രോഗിയുടെ വിവരങ്ങൾ",
  type_of_visit: "സന്ദർശനത്തിന്റെ തരം",
  opd: "ഔട്ട്-പേഷ്യൻറ്",
  ipd: "ഇൻ-പേഷ്യൻറ്",
  emergency: "അത്യാഹിത സന്ദർശനം",
  department_visited: "സന്ദർശിച്ച വകുപ്പ്",
  date_of_visit: "സന്ദർശിച്ച തീയതി",

  // Doctor & Care
  doctor_experience: "ഡോക്ടറുമായുള്ള അനുഭവവും പരിചരണവും",
  consultant_doctor: "കൺസൾട്ടൻറ് ഡോക്ടർ",
  timely_medication_care: "സമയബന്ധിതമായ മരുന്നും പരിചരണവും",

  // Appointment & Registration
  appointment_registration: "ബുക്കിംഗും രജിസ്ട്രേഷനും",
  ease_of_appointment: "അപ്പോയിന്റ്മെന്റ് ലഭ്യമാക്കാനുള്ള സൗകര്യം",
  info_about_doctor: "ഡോക്ടറെക്കുറിച്ചുള്ള വിവരങ്ങൾ",
  registration_courtesy: "രജിസ്ട്രേഷൻ ഡെസ്കിലെ ഊഷ്മളതയും മര്യാദയും",

  // Waiting Time
  waiting_time: "കാത്തിരിപ്പ് സമയം",
  waiting_comfort: "നിങ്ങളുടെ ഊഴത്തിനായി കാത്തിരിക്കുമ്പോൾ ഉണ്ടായ സൗകര്യം",

  // Staff
  staff_behavior: "സ്റ്റാഫിന്റെ പെരുമാറ്റവും ആശയവിനിമയവും",
  staff_courtesy: "സ്റ്റാഫിന്റെ മര്യാദയും സഹായ മനോഭാവവും",

  // Pharmacy
  pharmacy_experience: "ഫാർമസി അനുഭവം",
  medicine_availability: " നിർദ്ദേശിക്കപ്പെട്ട മരുന്നുകളുടെ ലഭ്യത ",
  pharmacy_courtesy_speed: "ഫാർമസി സേവനത്തിന്റെ മര്യാദയും വേഗതയും",

  // Billing
  billing_payment: "ബില്ലിംഗ് & പേയ്മെന്റ് പ്രക്രിയ",
  billing_transparency: "ബില്ലിംഗിന്റെ വ്യക്തതയും സുതാര്യതയും",

  // Cleanliness
  hospital_cleanliness: "ആശുപത്രിയുടെ ശുചിത്വം",
  cleanliness_hygiene: "വൃത്തിയും ശുചിത്വവും",

  // Overall Experience
  overall_experience: "മൊത്തമായുള്ള അനുഭവം",
  overall_experience_at_hospital: "ആശുപത്രിയിലെ നിങ്ങളുടെ മൊത്തമായുള്ള അനുഭവം",

  // Why You Chose
  why_choose_hospital: "എന്തുകൊണ്ടാണ് നിങ്ങൾ ഈ ആശുപത്രി തിരഞ്ഞെടുത്തത്?",
  doctor_recommendation: "ഡോക്ടറുടെ ശുപാർശ",
  location: "സ്ഥാനം",
  insurance_requirement: "ഇൻഷുറൻസ് ആവശ്യകതകൾ",
  friend_relative_recommendation: "സുഹൃത്ത്/ബന്ധുക്കളുടെ ശുപാർശ",
  past_experience: "കഴിഞ്ഞ അനുഭവം",
  online_reviews: "ഓൺലൈൻ റിവ്യൂകൾ / വെബ്സൈറ്റ്",
  hospital_reputation: "ആശുപത്രിയുടെ പ്രശസ്തി",
  other_reason: "മറ്റുള്ളവ",

  // NPS
  nps: "നെറ്റ് പ്രൊമോട്ടർ സ്കോർ (NPS)",
  nps_question:
    "0–10 എന്ന സ്കെയിലിൽ, ഈ ആശുപത്രി മറ്റുള്ളവർക്ക് ശുപാർശ ചെയ്യാൻ നിങ്ങൾ എത്രത്തോളം സാധ്യതയുണ്ട്?",

  // Suggestions
  suggestions: "നിർദ്ദേശങ്ങൾ / പരാതികൾ / അഭിനന്ദനങ്ങൾ",
  suggestions_placeholder:
    "നിങ്ങൾക്ക് ഇഷ്ടപ്പെട്ടതും മെച്ചപ്പെടുത്തുന്നതിനുള്ള നിർദ്ദേശങ്ങളും ദയവായി പങ്കിടുക.",

  // Contact Permission
  contact_permission: "ബന്ധപ്പെടുന്നതിനുള്ള അനുമതി",
  contact_permission_question:
    "നിങ്ങളുടെ ഫീഡ്ബാക്കിനെക്കുറിച്ച് ഞങ്ങൾ നിങ്ങളെ ബന്ധപ്പെടുന്നതിൽ താത്പര്യമുണ്ടോ?",
  yes: "ഉണ്ട്",
  no: "ഇല്ല",
  please_provide_it:'നിങ്ങൾക്ക് മറ്റൊരു നമ്പർ ഉണ്ടെങ്കിൽ, ദയവായി അത് നൽകുക.',
  alternative_mobile:'മറ്റൊരു മൊബൈൽ നമ്പർ',
},

};
